module.exports = function() {
  return new Worker(__webpack_public_path__ + "5e8104aa6f1ccf93c9e2.worker.js");
};